import React, { useEffect } from 'react';
import '../styles/HamburgerMenu.css';

/**
 * Hamburger menu component for mobile/tablet navigation
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the menu is open
 * @param {function} props.onToggle - Callback to toggle menu state
 * @param {React.ReactNode} props.children - Menu content
 */
function HamburgerMenu({ isOpen, onToggle, children }) {
  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <>
      {/* Hamburger button */}
      <button
        className={`hamburger ${isOpen ? 'hamburger--active' : ''}`}
        onClick={onToggle}
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isOpen}
      >
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>

      {/* Menu overlay */}
      {isOpen && (
        <div className="hamburger-overlay" onClick={onToggle}>
          <nav
            className="hamburger-menu"
            onClick={(e) => e.stopPropagation()}
            aria-label="Mobile navigation"
          >
            <div className="hamburger-menu-content">
              {children}
            </div>
          </nav>
        </div>
      )}
    </>
  );
}

export default HamburgerMenu;
